import type { PlanResponse } from '../types';
import { useI18n } from '../i18n';

export function NextActions({ plan }: { plan: PlanResponse }) {
  const { t } = useI18n();
  if (plan.nextActions.length === 0) {
    return <div className="empty">{plan.reasoning ?? ''}</div>;
  }
  return (
    <div className="stack">
      {plan.reasoning && <div className="mute">{plan.reasoning}</div>}
      <div className="action-list">
        {plan.nextActions.map((a, idx) => (
          <div key={idx} className="action-card">
            <div className="row-between">
              <div className="action-title">{a.title}</div>
              <span className={`pill pill-${a.priority}`}>{t(`priority.${a.priority}`)}</span>
            </div>
            <div className="action-why">{a.why}</div>
            <div className="action-meta">
              {typeof a.estimateMinutes === 'number' && (
                <span className="pill">~{a.estimateMinutes}m</span>
              )}
              {a.relatedItemIds?.slice(0, 3).map((id) => (
                <span key={id} className="pill">
                  {id.slice(0, 10)}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
